import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

import { useMemo, useRef } from 'react';
import styled from '@xstyled/styled-components';
import { Space } from 'antd';
import { QuestionType } from '@module/form';
import { MathEnabledTextComponent, styleVariables } from '@lib/common';
import MarkdownIt from 'markdown-it';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var Container = styled(Space)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  padding: 25px 35px;\n  border-radius: 16px;\n  box-shadow: 0px 3px 6px ", ";\n  background: ", ";\n  margin-bottom: 1em;\n  cursor: pointer;\n  overflow: hidden;\n  border: 1px solid ", ";\n  @media (max-height: ", "px) {\n    font-size: 0.725rem;\n  }\n"])), styleVariables.colors.transparentGray6, styleVariables.colors.gray1, function (props) {
  return props.active ? styleVariables.colors.blue3 : 'transparent';
}, styleVariables.responsive.tablet);
var ContentWrapper = styled(Space)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n  margin-bottom: 1em;\n  &.last-content {\n    margin-bottom: 0;\n  }\n"])));
var QuestionHeader = styled(Space)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: align-items;\n  justify-content: space-between;\n\n  width: 100%;\n\n  .ant-form-item {\n    margin-bottom: 0;\n  }\n"])));
var QuestionDescription = styled(MathEnabledTextComponent)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  cursor: pointer;\n\n  color: ", ";\n\n  p {\n    margin: 0;\n  }\n"])), styleVariables.colors.gray10);
var QuestionContentContainer = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  margin-bottom: 8px;\n"])));
var QuestionContentTitle = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 4px;\n  color: ", ";\n"])), styleVariables.colors.gray13);
var QuestionHeaderScore = styled.span(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  color: ", ";\n"])), styleVariables.colors.gray10);
var Explanation = styled(MathEnabledTextComponent)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  cursor: pointer;\n\n  color: ", ";\n\n  p {\n    margin: 0;\n  }\n"])), styleVariables.colors.gray10);
export var BaseQuestionPreview = function BaseQuestionPreview(props) {
  var question = props.question,
      children = props.children,
      active = props.active;
  var isHaveExplanation = useMemo(function () {
    return question.explanation && question.explanation.trim() && question.explanation.trim() !== '' && question.explanation.trim() !== '<p><br></p>';
  }, [question.explanation]);
  var isEssayQuestion = question.type === QuestionType.Essay;
  var md = useRef(new MarkdownIt());

  var convertMarkdown = function convertMarkdown(des) {
    if (md.current) {
      md.current.set({
        html: true
      }); // md convert description to render md

      var result = md.current.render(des);
      return result;
    }
  };

  return /*#__PURE__*/_jsxs(Container, {
    direction: "vertical",
    size: "middle",
    active: active,
    children: [/*#__PURE__*/_jsx(QuestionHeader, {
      children: /*#__PURE__*/_jsxs(QuestionHeaderScore, {
        children: [question.score, " \u0111i\u1EC3m"]
      })
    }), /*#__PURE__*/_jsxs(QuestionContentContainer, {
      children: [/*#__PURE__*/_jsx(QuestionContentTitle, {
        children: "C\xE2u h\u1ECFi"
      }), /*#__PURE__*/_jsx(QuestionDescription, {
        value: convertMarkdown(question.description)
      })]
    }), /*#__PURE__*/_jsxs(QuestionContentContainer, {
      children: [!isEssayQuestion && /*#__PURE__*/_jsx(QuestionContentTitle, {
        children: "\u0110\xE1p \xE1n "
      }), children]
    }), isHaveExplanation && /*#__PURE__*/_jsx(ContentWrapper, {
      direction: "vertical",
      className: "last-content",
      children: /*#__PURE__*/_jsxs(QuestionContentContainer, {
        children: [/*#__PURE__*/_jsx(QuestionContentTitle, {
          children: "Gi\u1EA3i th\xEDch "
        }), /*#__PURE__*/_jsx(Explanation, {
          value: question.explanation
        })]
      })
    })]
  });
};